/**
 * KrutiKala shop collection tabs
 * Figma Make: src/components/ShopCollection.tsx
 */
class KKShopTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab));
      tab.addEventListener('keydown', (event) => this.onKey(event, tab));
    });
  }

  activate(tab) {
    const id = tab.getAttribute('aria-controls');
    this.tabs.forEach((t) => {
      const selected = t === tab;
      t.setAttribute('aria-selected', selected ? 'true' : 'false');
      t.setAttribute('tabindex', selected ? '0' : '-1');
    });
    this.panels.forEach((panel) => {
      const match = panel.id === id;
      panel.hidden = !match;
      if (match) this.updateMoreLink(panel);
    });
  }

  updateMoreLink(panel) {
    const href = panel.dataset.kkShopMoreHref;
    const link = this.closest('.kk-shop')?.querySelector('[data-kk-shop-more]');
    if (href && link) link.href = href;
  }

  onKey(event, tab) {
    const index = this.tabs.indexOf(tab);
    let next = index;
    if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
    else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = this.tabs.length - 1;
    else return;
    event.preventDefault();
    this.tabs[next].focus();
    this.activate(this.tabs[next]);
  }
}

if (!customElements.get('kk-shop-tabs')) {
  customElements.define('kk-shop-tabs', KKShopTabs);
}
